<template>
  <div id="app">
    <!-- <preview v-if="previewShow.show" :DATA="previewShow"/> -->
    <router-view />
  </div>
</template>

<script>



// var overscroll = function(el) {
//   el.addEventListener('touchstart', function() {
//     var top = el.scrollTop
//       , totalScroll = el.scrollHeight
//       , currentScroll = top + el.offsetHeight
//     //If we're at the top or the bottom of the containers
//     //scroll, push up or down one pixel.
//     //
//     //this prevents the scroll from "passing through" to
//     //the body.
//     if(top === 0) {
//       el.scrollTop = 1
//     } else if(currentScroll === totalScroll) {
//       el.scrollTop = top - 1
//     }
//   })
//   el.addEventListener('touchmove', function(evt) {
//     //if the content is actually scrollable, i.e. the content is long enough
//     //that scrolling can occur
//     if(el.offsetHeight < el.scrollHeight)
//       evt._isScroller = true
//   })
// }
// overscroll(document.getElementById('app'));
// // document.addEventListener('touchmove', function(evt) {
// //   //In this case, the default behavior is scrolling the body, which
// //   //would result in an overflow.  Since we don't want that, we preventDefault.
// //   if(!evt._isScroller) {
// //     evt.preventDefault()
// //   }
// // })
import store from '@/store';
import { GetHistory } from '@/utils/storage';
// import preview from '@/components/preview'

export default {
  // components: {
  //   preview
  // },
  created() {
    store.dispatch('GetSystem');
    if(store.getters.token) {
      store.dispatch('RefreshUserInfo');
    }
    // 获取一下搜索历史
    let history = GetHistory('searchHistory') || [];
    // 
    store.dispatch('ChangeVmSearch', history)
  },
  // computed: {
  //   previewShow () {
  //     return this.$store.state.previewShow
  //   }
  // }
}
</script>

<style lang="less">
  // @import url("//at.alicdn.com/t/font_842373_37apgs8t0s2.css");
  @import url("//at.alicdn.com/t/font_842373_rrauwff7rrm.css");

  // @import url("//at.alicdn.com/t/font_1161655_h7d4xe25ybi.css");

  html, body, p, div, h1, h2, h3 {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: calc(100vw / 7.5);
    height: 100%;
    background-color: #F0F1F2;
  }

  body {
    font-size: 14px;
    height: 100%;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }

</style>
